export default {
	legend: {
		display: true,
		position: "bottom",
	},
}